import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormComponent} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {TranslateService} from '@ngx-translate/core';
import {Assignment} from '../assignment/assignment.model';
import {AssignmentService} from '../assignment/assignment.service';
import {ThroughputService} from './throughput.service';
import {Throughput} from './throughput.model';
import {ChannelService} from '../channel/channel.service';
import {Channel} from '../channel/channel.model';
import {ProductService} from '../product/product.service';
import {Product} from '../product/product.model';
import {FormWizardService} from '@brands-compart/form-wizard';

@Component({
  selector: 'app-throughput-form',
  templateUrl: './throughput-form.component.html'
})
export class ThroughputFormComponent extends FormComponent implements OnInit, OnDestroy {

  public formTitle: string;
  public stateIdParam: string = 'throughputId';
  public assignment: Assignment;
  public channel: Channel;
  public products: Product[];
  public throughput: Throughput = new Throughput();
  public throughputFields: any = [];
  public formThroughputValues;
  private formWizardService: FormWizardService;
  public forceEditMode: boolean = (this.router.stateService.params.forceEdit === 'true');

  constructor(
    protected router: UIRouter,
    private translate: TranslateService,
    private assignmentService: AssignmentService,
    private channelService: ChannelService,
    private throughputService: ThroughputService,
    private productService: ProductService
  ) {
    super(router);

    this.formWizardService = new FormWizardService();
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.throughputService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}/channel/${this.router.stateService.params.channelId}`);

    const promises: Promise<any>[] = [];

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('throughput.form.add.formTitle').subscribe((translate) => {
          this.formTitle = translate;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.translate.get('throughput.form.edit.formTitle').subscribe((translate) => {
          this.formTitle = translate;
        });

        promises.push(new Promise((resolve) => {
          this.throughputService.get(this.router.stateService.params[this.stateIdParam]).subscribe((throughput: Throughput) => {
            this.throughput = throughput;
            resolve(throughput);
          });
        }));
      } break;
    }

    promises.push(new Promise((resolve) => {
      this.channelService.get(this.router.stateService.params.channelId).subscribe((channel: Channel) => {
        this.channel = channel;
        resolve(channel);
      });
    }));

    promises.push(new Promise((resolve) => {
      this.productService.getAll().subscribe((products: Product[]) => {
        const productsMapping = {};

        for(let i = 0; i < products.length; i++) {
          productsMapping[products[i].productGroup] = productsMapping[products[i].productGroup]  || [];
          productsMapping[products[i].productGroup].push(products[i]);
        }

        const formattedProducts = [];
        const productGroups = Object.keys(productsMapping);
        for(let i = 0; i < productGroups.length; i++) {
          formattedProducts.push({
            key: productGroups[i],
            options: productsMapping[productGroups[i]].map((product: Product) => {
              return product.toKeyValueOption();
            })
          });
        }

        this.products = formattedProducts;
        resolve(products);
      });
    }));

    promises.push(new Promise((resolve) => {
      this.assignmentService.get(this.router.stateService.params.assignmentId).subscribe((assignment: Assignment) => {
        this.assignment = assignment;
        resolve(assignment);
      });
    }));

    Promise.all(promises).then(() => {

      const throughputData = {
        viewMode: (this.assignment.status === 'PROCESSED' && !this.forceEditMode),
        products: this.products,
        channel: this.channel,
        throughput: this.throughput,
      };

      this.formWizardService.initThroughputField(throughputData);

      this.formWizardService.throughputFields.subscribe((fields) => {
        this.throughputFields = fields;
      });
      this.formThroughputValues = this.formWizardService.throughputFormValues;
    });
  }

  ngOnDestroy(): void {
    this.throughputService.clearRoutePrefix();
  }

  public changeThroughputField(evt: string, field: any) {
    this.formWizardService.setThroughputField({
      key: `throughput.${field.key}`,
      value: evt
    });
  }

  public save() {


    const throughputData = {
      products: this.products,
      channel: this.channel,
      throughput: this.throughput
    };

    this.formWizardService.validateThroughputModel(JSON.parse(JSON.stringify(throughputData))).then((result) => {
      // if(result.isValid) {
        switch(this.formMode) {
          case this.FormMode.ADD: {
            const currentStateParts = this.router.stateService.$current.name.split('.throughput.');
            const parentState = currentStateParts[0];

            this.throughputService.add(this.throughput).subscribe((response) => {
              this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
            });
          } break;

          case this.FormMode.UPDATE: {
            const currentStateParts = this.router.stateService.$current.name.split('.');
            currentStateParts.pop();
            currentStateParts.pop();
            const parentState = currentStateParts.join('.');

            this.throughputService.update(this.throughput).subscribe((response) => {
              this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
            });
          } break;
        }
      // }
    });
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/throughput/throughput-form.component.ts